export default "__VITE_ASSET__ClEP_mCz__"